// src/components/withRouterData.jsx
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';


// Función para inyectar los datos de React Router (location, params, etc.) en un componente de clase
function withRouterData(Component) {
  // Este es un componente funcional que usa el hook y renderiza tu componente de clase
  function ComponentWithRouterData(props) {
    const location = useLocation(); // Hook para acceder a los datos de la ruta/navegación
    let params = useParams();
    
    // Pasa 'location' y cualquier otro prop a tu componente de clase como 'props'
    return <Component {...props} location={location} router={{ params }} />;
  }

  // Asigna un nombre amigable para depuración
  ComponentWithRouterData.displayName = `withRouterData(${Component.displayName || Component.name})`;

  return ComponentWithRouterData;
}

export default withRouterData;